<template>
  <main id="main">
    <transition name="fade">
      <Loader v-if="!$page" />
    </transition>
    <template v-if="$page">
      <HomeHeader :content="$page.header" />
      <IntroductionSection :content="{ experiences: $page.experiences, history: $page.history }" />
      <BannerSection :content="$page.banner" />
      <PresentationSection :content="{ advantages: $page.advantages, values: $page.values }" />
      <TestimoniesSection :content="$page.testimonies" />
      <ProfilesSection :content="$page.profiles" />
      <JobsSection :content="$page.jobs" />
      <FormSection :content="$page.spontaneous" />
    </template>
  </main>
</template>

<script>
import BannerSection from '@/components/sections/BannerSection.vue'
import FormSection from '@/components/sections/FormSection.vue'
import HomeHeader from '@/components/sections/HomeHeader.vue'
import IntroductionSection from '@/components/sections/IntroductionSection.vue'
import JobsSection from '@/components/sections/JobsSection.vue'
import PresentationSection from '@/components/sections/PresentationSection.vue'
import ProfilesSection from '@/components/sections/ProfilesSection.vue'
import TestimoniesSection from '@/components/sections/TestimoniesSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  name: 'Home',
  beetPage: 'home',
  mixins: [PageMetaMixin],
  components: {
    BannerSection,
    FormSection,
    HomeHeader,
    IntroductionSection,
    JobsSection,
    Loader,
    PresentationSection,
    ProfilesSection,
    TestimoniesSection,
  },
}
</script>
